// Google驗證碼使用說明頁面翻譯
export default {
  title: "如何使用谷歌驗證碼",
  intro:
    "身分驗證器，通常指一種軟體或硬體工具，用於生成一次性、短時間有效的驗證碼，作為登入帳戶時的第二道安全憑證。它的主要目的是用於雙因素或多因素驗證。您可以把它理解為一個不斷生成動態密碼的「電子令牌」或「數位鑰匙」。使用身分驗證器的整個過程可以分為兩大步：",

  // 微信小程序使用方式
  wechatMethod: {
    title: "1、微信小程序",
    step1: '第一步：在微信搜索"騰訊身份驗證器"或者"寧盾令牌"進入小程序',
    step2: "第二步：請將小程序中你綁定的動態數字輸入驗證碼輸入框",
  },

  // 手機App使用方式
  appMethod: {
    title:
      "2、手機寧盾令牌（iOS和Android手機用戶）或者google authenticator（僅限iOS手機用戶）",
    step1: "第一步：在App Store或者安卓應用市場搜索對應app然後下載",
    step2: "第二步：請將 App中你綁定的動態數字輸入驗證碼輸入框",
  },
};
